import { ColorUnion, Colors, type MediumIcon } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { WizardData, WizardDataField } from './policy_types'

const validateMandatory = (field: WizardDataField, data: WizardData) => {
  const value = data[field]
  if (Array.isArray(value)) {
    return !!value.length
  }
  return !!data[field]
}

export interface CategoryListItem {
  icon: MediumIcon
  badgeColor: Colors
  color: Colors
  amountTagColor: ColorUnion
  title?: string
  value?: string
  hide?: boolean
}

export const categoryTemplateList = (): CategoryListItem[] => [
  {
    icon: 'coffee',
    color: 'viridian1000',
    badgeColor: 'viridian200',
    amountTagColor: 'viridian',
    title: i18n.t('spending_policies.wizard.steps.policy_template.meals'),
    value: 'restaurants',
  },
  {
    icon: 'business-trip',
    color: 'purple1000',
    badgeColor: 'purple200',
    amountTagColor: 'purple',
    title: i18n.t('spending_policies.wizard.steps.policy_template.travel'),
    value: 'travel',
  },
  {
    icon: 'push-pin',
    color: 'lime1000',
    badgeColor: 'lime200',
    amountTagColor: 'lime',
    title: i18n.t('spending_policies.wizard.steps.policy_template.transport'),
    value: 'transport',
  },
  {
    icon: 'crown',
    color: 'fuchsia1000',
    badgeColor: 'fuchsia200',
    amountTagColor: 'fuchsia',
    title: i18n.t('spending_policies.wizard.steps.policy_template.clients'),
    value: 'clients',
  },
  {
    icon: 'projects',
    color: 'champagne1000',
    badgeColor: 'champagne200',
    amountTagColor: 'champagne',
    title: i18n.t('spending_policies.wizard.steps.policy_template.work_conditions'),
    value: 'work_conditions',
  },
  {
    icon: 'academic-cap',
    color: 'malibu1000',
    badgeColor: 'malibu200',
    amountTagColor: 'malibu',
    title: i18n.t('spending_policies.wizard.steps.policy_template.training'),
    value: 'training',
  },
]

export const categoryTemplateListExtended = (): CategoryListItem[] => [
  {
    icon: 'coffee',
    color: 'viridian1000',
    badgeColor: 'viridian200',
    amountTagColor: 'viridian',
  },
  {
    icon: 'business-trip',
    color: 'purple1000',
    badgeColor: 'purple200',
    amountTagColor: 'purple',
  },
  {
    icon: 'push-pin',
    color: 'lime1000',
    badgeColor: 'lime200',
    amountTagColor: 'lime',
  },
  {
    icon: 'crown',
    color: 'fuchsia1000',
    badgeColor: 'fuchsia200',
    amountTagColor: 'fuchsia',
  },
  {
    icon: 'projects',
    color: 'champagne1000',
    badgeColor: 'champagne200',
    amountTagColor: 'champagne',
  },
  {
    icon: 'academic-cap',
    color: 'malibu1000',
    badgeColor: 'malibu200',
    amountTagColor: 'malibu',
  },
  {
    icon: 'expenses',
    color: 'tangerine1000',
    badgeColor: 'tangerine200',
    amountTagColor: 'tangerine',
  },
  {
    icon: 'office',
    color: 'viridian1000',
    badgeColor: 'viridian200',
    amountTagColor: 'viridian',
  },
  {
    icon: 'manager',
    color: 'purple1000',
    badgeColor: 'purple200',
    amountTagColor: 'purple',
  },
  {
    icon: 'money-bag',
    color: 'radicalRed800',
    badgeColor: 'radicalRed100',
    amountTagColor: 'radical',
  },
]

export const customCategory = (): CategoryListItem => ({
  icon: 'logo-avatar',
  color: 'radicalRed1000',
  badgeColor: 'radicalRed200',
  amountTagColor: 'malibu',
  title: i18n.t('spending_policies.wizard.steps.policy_template.custom'),
  value: 'custom',
})

const getInvalidMandatoryFields = (mandatoryFields: WizardDataField[], data: WizardData) => {
  return mandatoryFields
    .map((field) => {
      return validateMandatory(field, data)
        ? null
        : { [field]: i18n.t('budgets.forms.errors.mandatory') }
    })
    .filter(Boolean)
}

export const validateMandatoryFields = (mandatoryFields: WizardDataField[], data: WizardData) => {
  const invalidFields = getInvalidMandatoryFields(mandatoryFields, data)

  const getDataWithErrors = () => {
    const errors = Object.assign({}, ...invalidFields)

    return {
      ...data,
      errors,
    }
  }
  return {
    dataWithErrors: getDataWithErrors(),
    invalidFields,
  }
}
